import $ from 'expose-loader?exposes=$,jQuery!jquery'
import { drag } from './ui'
import { uaMatch } from './utils'

/* Fix for IE window.location issues */
window.MSStream && window.addEventListener("DOMContentLoaded", function () {
  let base = document.getElementsByTagName('base')[0].href,
    links = document.getElementsByTagName('a')
  for (let l = links.length, i = 0; l > i; i++) {
    let a = links[i], href = a.getAttribute("href")
    if (href && href.indexOf('http') !== 0 && href.indexOf('/') !== 0) {
      a.setAttribute("href", base + href)
    }
  }
})

document.createElement('header')
document.createElement('nav')
document.createElement('section')
document.createElement('article')
document.createElement('aside')
document.createElement('footer')
document.createElement('hgroup')

let matched = uaMatch(navigator.userAgent),
  browser = {}
if (matched.browser) {
  browser[matched.browser] = true;
  browser.version = matched.version;
}

// Chrome is Webkit, but Webkit is also Safari.
if (browser.chrome) {
  browser.webkit = true
} else if (browser.webkit) {
  browser.safari = true
}

jQuery.browser = browser;

$(document).ready(function () {
  (function (root, factory) {
    if (typeof define === 'function' && define.amd) {
      define(['exports'], factory);
    } else if (typeof exports !== 'undefined') {
      factory(exports)
    } else {
      factory((root.dragscroll = {}))
    }
  }(this, drag))

  const currForm = $('#currform')
  if (!currForm.find('div.currency').length && currForm.find('p').length) {
    const p = currForm.find('p')
    const html = $(p).html()
    currForm.prepend('<div class="currency">' + html + '</div>')
    $(p).remove()
  }
})

export function setCookie(name, value, days) {
  let expires = ""
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = "; expires=" + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

export function getCookie(name) {
  const nameEQ = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;'
}

export function deleteVouchers() {
  $('.vouchers-table td input[type=checkbox]:checked').each(function (index, element) {
    const that = $(this)
    $.get($(this).parents('tr').find('a').attr('href'), () => {
      that.parents('tr').next('.empty-row').remove()
      that.parents('tr').remove()
    })
  })
}

export function handleDomainWidgets(tpl) {
  let selected_domain_ids = []

  const updater = $('#updater'),
    change_all = $('#change-all'),
    widgets = $('.domain-widgets a'),
    selected = $('.selected-names')

  function update_selected() {
    const self = $(this),
      id = self.val(),
      checked = self.is(':checked'),
      added = selected_domain_ids.hasOwnProperty(id)

    if (checked && !added) {
      let selection = $(tpl.replace('%name', self.data('name'))),
        cloned = self.clone().attr('type', 'hidden')

      selected_domain_ids[id] = selection

      selection.data({
        rel: self,
        id: id
      })
      selection.append(cloned)
      selected.append(selection).append(' ')
    } else if (!checked && added) {
      selected_domain_ids[id].remove()
      delete selected_domain_ids[id]
    }
  }

  function update_widgets() {
    var ids = Object.keys(selected_domain_ids);

    if (!ids.length) {
      widgets.addClass('disabled')
      return
    }

    $.getJSON(
      '?cmd=clientarea&action=domains&make=widgetsget',
      { ids: ids },
      data => {
        widgets.addClass('disabled');
        widgets.filter('.widget_domainrenewal').removeClass('disabled')
        $.each(
          data.resp,
          (index, i) => widgets.filter('.widget_' + i.widget).removeClass('disabled')
        )
      }
    )
  }

  change_all.on('change', function () {
    const self = this
    updater.find('input[type=checkbox]').each(function () {
      this.checked = self.checked
      update_selected.call(this)
    })
    update_widgets()
  })

  widgets.on('click', function () {
    const ids = Object.keys(selected_domain_ids)
    let i, len = ids.length

    if (!ids.length) {
      return false
    }

    let query = ''
    for (i = 0; i < len; i++) {
      query += '&ids[]=' + ids[i]
    }

    window.location = $(this).attr('href') + query
    return false
  })

  updater.on('ajaxupdate', function () {
    change_all.prop('checked', false);
    updater.find('input[type=checkbox]').each(function () {
      this.checked = selected_domain_ids.hasOwnProperty(this.value)
    })
  })

  updater.on('change', 'input[type=checkbox]', function () {
    update_selected.call(this)
    update_widgets()
  })

  selected.on('click', 'a', function (e) {
    e.preventDefault()

    const self = $(this),
      rel = self.data('rel'),
      id = self.data('id');

    if ($.contains(document.documentElement, rel.get(0))) {
      rel.prop('checked', false)
    } else {
      rel.remove()
    }

    if (selected_domain_ids.hasOwnProperty(id)) {
      delete selected_domain_ids[id]
    }
    self.remove()
    update_widgets()
    return false
  })

  change_all.prop('checked', false).trigger('change')
}
